const HIDE_BOTTOM_NAV_PREFIXES = [
    "/application",
    "/dog",
    "/provider",
    "/doomscroll",
    "/filter-quiz",
    "/feedback",
    "/demo",
    "/wrapped",
    "/internal",
    "/kennel",
];

const STANDALONE_PAGES = ["/ari", "/kinako-hill-shibas"];

export function matchesRoutePrefix(pathname: string, prefix: string) {
    return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function isStandalonePage(pathname: string) {
    return STANDALONE_PAGES.some((page) => matchesRoutePrefix(pathname, page));
}

export function routeHasBottomNav(pathname: string) {
    return (
        !isStandalonePage(pathname) &&
        !HIDE_BOTTOM_NAV_PREFIXES.some((prefix) =>
            matchesRoutePrefix(pathname, prefix),
        )
    );
}

export function shellNavigationLayout({
    pathname,
    bottomNavSuppressed,
    chatOpen,
    reachOutSheetOpen,
    reachOutSheetExiting,
}: {
    pathname: string;
    bottomNavSuppressed: boolean;
    chatOpen: boolean;
    reachOutSheetOpen: boolean;
    reachOutSheetExiting: boolean;
}) {
    const showBottomNav =
        !bottomNavSuppressed &&
        !chatOpen &&
        !reachOutSheetOpen &&
        !reachOutSheetExiting &&
        routeHasBottomNav(pathname);
    const reserveBottomNavSpace =
        showBottomNav &&
        pathname !== "/faq" &&
        !pathname.startsWith("/discover") &&
        !pathname.startsWith("/profile");
    return { showBottomNav, reserveBottomNavSpace };
}
